<template>
  <div class="register-wrap">
    <authLeft />
    <div class="register-right">
      <div class="register-form">
        <div class="register-form-title">ログイン</div>
        <div class="register-form-session">
          他端末または他ブラウザでログイン中か、一定時間が経過したためログアウトされました。
          <br />再度ログインしてください。
        </div>
        <div class="register-form-subtitle">メールアドレス</div>
        <el-input placeholder="メールアドレス" v-model="username" @keypress.enter.native="login"></el-input>
        <div class="register-form-subtitle">パスワード</div>
        <el-input placeholder="パスワード" v-model="password" show-password @keypress.enter.native="login"></el-input>
        <!-- <div class="register-form-subtitle">パスワード(再入力)</div>
        <el-input placeholder="パスワード" v-model="form.password2" show-password></el-input>-->
        <el-button style="width:100%; margin-top:30px;" type="primary" @click="login" :disabled="loading">
          <div class="flex-row">
            再ログイン
            <div class="loader--mini" v-show="loading"></div>
          </div>
        </el-button>
        <router-link to="/password_reset">
          <div style="margin-top:10px" class="router-link">パスワードを忘れた方</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const loginAPI = root + "/api/auth/login";
const protocol = window.location.protocol; // "http:" または "https:"
const hostname = window.location.hostname; // "127.0.0.1"
const port = window.location.port; // "8080"
const fullUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;

export default {
  name: "register",
  components: {
    authLeft,
  },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      data: [],
      uid: "",
    };
  },
  computed: {},
  mounted() {
    this.browserCheck();
    this.mobileCheck();
  },
  methods: {
    browserCheck() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("msie") != -1 || userAgent.indexOf("trident") != -1) {
        this.$router.push({ path: "/incompatible" });
      } else if (userAgent.indexOf("edg") != -1) {
        console.log("");
      } else if (userAgent.indexOf("chrome") != -1) {
        console.log("");
      } else if (userAgent.indexOf("safari") != -1) {
        this.$router.push({ path: "/incompatible" });
      } else if (userAgent.indexOf("firefox") != -1) {
        console.log("");
      } else if (userAgent.indexOf("opera") != -1) {
        console.log("");
      } else {
        console.log("");
      }
    },
    mobileCheck() {
      if (this.$mq == "sp") {
        this.$router.push({ path: "/incompatible" });
      }
    },
    login() {
      this.loading = true;
      this.$store.dispatch("reset");
      firebase
        .auth()
        .signInWithEmailAndPassword(this.username, this.password)
        .then((authData) => {
          this.axios
            .get(loginAPI, {
              params: {
                user_token: authData.user.uid,
                accessUrl: fullUrl,
              },
            })
            .then((response) => {
              this.$store.dispatch("getUserData", { token: response.data.token, user_token: response.data.user_token }).then(() => {
                this.$router.push("/dashboard");
                this.loading = false;
              });
            });
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("メールアドレスかパスワードが間違っています。");
        });
    },
  },
};
</script>
